<div
  class=""
  style="
    background-image: url('/src/assets/images/emblembg.png');
    background-repeat: no-repeat;
    background-position: center;
    background-size: 45%;
  "
>
  <app-modal-header [title]="title" (closeModal)="closeModal($event)"></app-modal-header>
  <mat-dialog-content [formGroup]="approvalFlowStagesForm">
    <div class="row">
      <div class="col-md-12">
        <mat-form-field
          appearance="outline"
          class="material-form w-full rounded-3xl"
        >
          <mat-label>Stages Name</mat-label>
          <input
            formControlName="stageName"
            matInput
            placeholder="Stages Name"
            class=""
          />
          <mat-error>
            <span
              *ngIf="
                !approvalFlowStagesForm.get('stageName').valid &&
                approvalFlowStagesForm.get('stageName').touched
              "
            >
              Field is required
            </span>
          </mat-error>
        </mat-form-field>
      </div>
      <div class="col-md-12">
        <mat-form-field appearance="outline" class="material-form w-100">
          <mat-label>Designation</mat-label>
          <mat-select formControlName="stageDesignation">
            <mat-option
              *ngFor="let designation of stageDesignation$ | async"
              [value]="designation.designationUniqueId"
            >
              <span>{{ designation?.designationName | language: 'sw' }}</span>
              @if (designation?.designationName | language: 'en') {
                <span class="text-[11px] text-muted">({{ designation?.designationName | language: 'en' }})</span>
              }
            </mat-option>
          </mat-select>
          <mat-error>
            <span
              *ngIf="!approvalFlowStagesForm.get('stageDesignation').valid && approvalFlowStagesForm.get('stageDesignation').touched">
              Field is required.
            </span>
          </mat-error>
        </mat-form-field>
      </div>
      <div class="col-md-12">
        <mat-checkbox formControlName="stageIsStarting" color="primary" matInput
          >Is stage Starting</mat-checkbox
        >

        <mat-checkbox
          formControlName="stageIsEnding"
          color="primary"
          class="ml-10"
          >Is stage Ending</mat-checkbox
        >
      </div>
    </div>
    <div class="row">
      <div class="col">
        <div class="d-flex justify-end mt-2">
          <button
            [disabled]="approvalFlowStagesForm?.invalid"
            class="bg-primary-500 px-3 py-2 rounded-3xl text-white"
            (click)="submitForm(approvalFlowStagesForm.value)">
            Submit
          </button>
        </div>
      </div>
    </div>
  </mat-dialog-content>
</div>
